export default __webpack_public_path__ + "static/img2-5c12d04a0e42fb8e54966c66ae125379.png";